import {match} from 'ts-pattern';

/**
 * Mirrors the BE OutboundTitleExtensionClamp cut so the FE tooltip preview matches what
 * the export sends: cut at the limit, back off to the last word boundary (hard cut when
 * a single word exceeds the limit), no trailing space, no ellipsis. The preview is
 * indicative — the BE clamp is the authority.
 */
export function truncateTitleAtWordBoundary(value: string, maxLength: number): string {
  if (value.length <= maxLength) {
    return value;
  }

  const hardCut = value.slice(0, maxLength).trimEnd();
  const lastSpace = hardCut.lastIndexOf(' ');
  const isCutOnWordBoundary = value.charAt(maxLength) === ' ';

  return match({isCutOnWordBoundary, lastSpace})
    .with({isCutOnWordBoundary: true}, () => hardCut)
    .when(
      ({lastSpace: space}) => space <= 0,
      () => hardCut
    )
    .otherwise(() => hardCut.slice(0, lastSpace).trimEnd());
}
